/**
 * @generated SignedSource<<3b0ed694e3079c92ecb492f1a5099524>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleListItemTimeOfDay_TeamScheduleEventOccasion$data = {
  readonly __typename: "RoutineOccasion";
  readonly deadlineAtDate: {
    readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
  } | null;
  readonly startAtDate: {
    readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
  };
  readonly " $fragmentType": "TeamScheduleListItemTimeOfDay_TeamScheduleEventOccasion";
} | {
  readonly __typename: "TeamScheduleInlineRoutineOccasion";
  readonly taskExecution: {
    readonly routineOccasion: {
      readonly deadlineAtDate: {
        readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
      } | null;
      readonly startAtDate: {
        readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
      };
    };
  };
  readonly " $fragmentType": "TeamScheduleListItemTimeOfDay_TeamScheduleEventOccasion";
} | {
  readonly __typename: "TeamScheduleOneOffEvent";
  readonly endAtDate: {
    readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
  };
  readonly startAtDate: {
    readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
  };
  readonly " $fragmentType": "TeamScheduleListItemTimeOfDay_TeamScheduleEventOccasion";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "TeamScheduleListItemTimeOfDay_TeamScheduleEventOccasion";
};
export type TeamScheduleListItemTimeOfDay_TeamScheduleEventOccasion$key = {
  readonly " $data"?: TeamScheduleListItemTimeOfDay_TeamScheduleEventOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleListItemTimeOfDay_TeamScheduleEventOccasion">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "args": [
      {
        "kind": "Literal",
        "name": "style",
        "value": "TIME_ONLY"
      }
    ],
    "kind": "FragmentSpread",
    "name": "StoreFormattedDate"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreZonedDate",
  "kind": "LinkedField",
  "name": "startAtDate",
  "plural": false,
  "selections": (v0/*: any*/),
  "storageKey": null
},
v2 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreZonedDate",
    "kind": "LinkedField",
    "name": "deadlineAtDate",
    "plural": false,
    "selections": (v0/*: any*/),
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleListItemTimeOfDay_TeamScheduleEventOccasion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v2/*: any*/),
      "type": "RoutineOccasion",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TaskExecutionCheck",
          "kind": "LinkedField",
          "name": "taskExecution",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoutineOccasion",
              "kind": "LinkedField",
              "name": "routineOccasion",
              "plural": false,
              "selections": (v2/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "TeamScheduleInlineRoutineOccasion",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "StoreZonedDate",
          "kind": "LinkedField",
          "name": "endAtDate",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "type": "TeamScheduleOneOffEvent",
      "abstractKey": null
    }
  ],
  "type": "TeamScheduleEventOccasion",
  "abstractKey": "__isTeamScheduleEventOccasion"
};
})();

(node as any).hash = "ad9308f6242cda6b8365f696e50a9fff";

export default node;
